import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query GetPlanetsActivities(
    $filter: NFTActivityFilterInput
    $filterInput: GetPlanetsFilterInput
    $pagingInput: PagingInput!
    $skipTotal: Boolean = false
  ) {
    getPlanetActivities(
      filter: $filter
      filterInput: $filterInput
      pagingInput: $pagingInput
    ) {
      edges {
        node {
          activityType
          currencyCode
          network
          price
          tokenId
          transactionHash
          transactionTime
          toAccount {
            walletAddress
            name
          }
          fromAccount {
            walletAddress
            name
          }
        }
      }
      pageInfo {
        ...PageInfoSkipTotal @include(if: $skipTotal)
        ...PageInfo @skip(if: $skipTotal)
      }
    }
  }

  ${PageInfoFragment}
`
